import { polyfill } from 'mobile-drag-drop';
import { scrollBehaviourDragImageTranslateOverride } from 'mobile-drag-drop/scroll-behaviour';

// Initialize the polyfill for iOS/iPadOS touch-to-drag support
polyfill({
  dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
});

// Fix for iOS 10+ preventing scrolling while dragging
window.addEventListener('touchmove', function () {}, { passive: false });
